var Kowloon = "九龍";
var HKStates = {
	"Hong Kong Island": "香港島",
	Kowloon: Kowloon,
	"Lantau Island": "ランタオ島",
	"New Territories": "新界"
};

export { Kowloon, HKStates as default };
